export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8904.5f0b1321.jpg";